import React from "react";
import Underline from '../img/underline.png';
import {Bar} from "react-chartjs-2";

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend
} from "chart.js";

    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Tooltip,
        Legend
    )

    const health_records = [
        {month:"January", cases_reported:14963, deaths:147},
        {month:"February", cases_reported:16141, deaths:158},
        {month:"March", cases_reported:22639, deaths:225},
        {month:"April", cases_reported:35107, deaths:372},
        {month:"May", cases_reported:33743, deaths:598},
        {month:"June", cases_reported:33618, deaths:458},
        {month:"July", cases_reported:31393, deaths:435},
        {month:"August", cases_reported:25956, deaths:310},
        {month:"September", cases_reported:21471, deaths:244},
        {month:"October", cases_reported:19003, deaths:224},
        {month:"November", cases_reported:16644, deaths:208},
        {month:"December", cases_reported:14757, deaths:177},
    ];

    const barColorsCases = "rgba(255, 163, 107, 0.8)"
    const barBorderColorsCases = "rgba(232, 87, 0, 0.8)"
    const barColorsCasesDeaths = "rgba(166, 255, 223, 0.8)"
    const barBorderColorsDeaths = "#118C5F"

const Covid = () => {
    
    return(
        <section id="covid" class="pt-10 px-6 py-10 max-[420px]:px-2">
            <div className='mb-10'>
                <h1 class="text-5xl text-center font-bold max-md:text-5xl max-md:text-center max-sm:text-4xl" style={{color:"#118C5F"}}>COVID DETAILS</h1>
                <div className='flex justify-center mt-5'>
                    <img src={Underline} alt="about"/>
                </div>
            </div>
            <div class="my-3 px-5 py-5 leading-10 text-gray-800 text-justify text-lg max-[420px]:px-3 mx-3">
                <p>
                    The hypothetical data indicates a consistent rise in confirmed cases and simulated deaths attributed to a simulated outbreak of COVID-19 
                    in Kenya throughout the simulated year of 2022. Simulated records point to a peak in both cases and simulated deaths occurring in the simulated month of December. </p>
            </div>
            <div id="chart" class="mx-10 my-3 px-5 py-5 border-2 rounded-3xl shadow-xl shadow-slate-300 max-[670px]:w-0 max-[670px]:border-0 max-[670px]:shadow-none max-[670px]:my-0 max-[670px]:py-0" style={{border:"1", borderColor:"#118C5F"}}>
                <Bar data={{
                    labels: health_records.map(month => month.month),
                    datasets: [
                        {
                            label: "Number of Covid Cases Recorded in 2022",
                            data: health_records.map(cases_reported => cases_reported.cases_reported),
                            backgroundColor:barColorsCases,
                            borderColor:barBorderColorsCases,
                            borderWidth:3,
                            borderRadius:3
                        },
                        {
                            label: "Number of Deaths Recorded in 2022",
                            data: health_records.map(cases_reported => cases_reported.cases_reported),
                            backgroundColor:barColorsCasesDeaths,
                            borderColor:barBorderColorsDeaths,
                            borderWidth:3,
                            borderRadius:3
                        },
                        
                    ]
                }}

                />
            </div>
        </section>
    )
}

export default Covid;